import styled from 'styled-components'

export interface TooltipWrapperUiProps {
  isFlex?: boolean
}

export const TooltipWrapperUi = styled.div<TooltipWrapperUiProps>`
  position: relative;
  display: ${p => (p.isFlex ? 'flex' : 'block')};
`